import { createSelector } from "@reduxjs/toolkit";
import _ from "lodash";
import { getOpeningStatus } from "../../utils/openingHours";

export const storeSelector = (state) => state.store;

export const pickupLocationsSelector = createSelector(
  storeSelector,
  (store) => store.pickupLocations
);

export const pickupLocationsByIdSelector = createSelector(
  pickupLocationsSelector,
  (pickupLocations) => _.keyBy(pickupLocations, "id")
);

export const openingHoursSelector = createSelector(storeSelector, (self) =>
  [...self.openingHours].sort((a, b) => a.weekday - b.weekday)
);

export const isNowBetweenWorkingHoursSelector = (state) =>
  getOpeningStatus(openingHoursSelector(state)).isOpen;
